import md5 from 'blueimp-md5'
import qs from 'qs'

/**
 * 根据参数计算签名
 * @param {Object} params
 */
function getSign(params: any = {}) {
  // 按照参数名称字母先后进行排序
  const paramStr = Object.keys(params)
    .sort()
    .map((key: any) => {
      return key + `${params[key]}`.trim()
    })
    .join('')
  const signKey = '#$%^&*RT&YU!@#$19'
  return md5(`${signKey}${paramStr}`)
}

/**
 * 异常上报记录日志
 * @param {Object} params
 * @param {string} params.system - h5 / miniprogram
 * @param {string} params.serviceName - wxauthorize / order
 * @param {string} params.method - wxauthorize / pay
 * @param {string} params.message
 * @param {string} params.level - notice / fatal
 */
function monitorLog(params: any = {}) {
  const { system, serviceName, method, message = '', level = 'notice' } = params
  if (!system || !serviceName || !method) {
    console &&
      console.error(`'skip monitorLog for params invalid, params: ${params}`)
    return
  }

  const data: any = {
    warSystem: system,
    warServiceName: serviceName,
    warMethod: method,
    warMsg: message,
    level,
  }
  data.feSign = getSign(data)
  const url: string = '/qudao/report/femonitorlog'
  const res: any =
    (<any>window).$axios && (<any>window).$axios.post(url, qs.stringify(data))

  // apm自定义打点
  try {
    ;(window as any).RangersSiteSDK('emit', 'counter', {
      name: '关键参数监控(支付授权二维码lastfrom)', // 指标名称
      value: 1, //指标值
      tags: data,
    })
  } catch (error) {
    console.log(error)
  }
}

export default {
  monitorLog,
}
